
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from './../../../config';
// import { myfetchThunk } from "../../../app/myfetch";


// Interface which is expected from api call
interface testdataResponsePayloadInterface{
    uuid: string,
    username: string,
    name: string,
    email: string,
    loginTries: number,
    locked: false,
    active: false,
    visible: false,
    archived: false,
    editable: false,
    passwordHash: string,
    salt: string,
    token: string,
    tokenValidUntil: string,
    status: string,
    aboutMe: string,
    language: string,
    phone: string,
    title: string,
    imageFile: string,
    location: string,
    skills: string,
    notes: string,
    lastSeen: string,
    otpSecret: string,
    lastMessageReadTime: string,
    mandantList: string,
    role: string,
    activeMandant: string,
    notification: string,
    created: string
}

export const requestUserCreationFromAPI =(data:any) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/Users",
            {data},
            "POST",
            (payload:testdataResponsePayloadInterface) => {
                console.log(btoa(payload.token))
                
                //dispatch(actions.showQrCode({token:payload.token}) as any);
                // dispatch state update action
                //dispatch(loginActions.doLogin({Login:payload.login}));
                // console.log(JSON.parse(payload.toString()))
                
            },
            (payload:any) => {
                console.log("ERROR")
                console.log(payload)
                // dispatch state update action
                //dispatch(loginActions.doLogin({Login:payload.login}));
                // console.log(JSON.parse(payload.toString()))
                
            },
        ) as any)
    }
}
